import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogSurface, DialogTitle, DialogActions, Subtitle1, Checkbox } from '@fluentui/react-components';

interface TenderingManagerDialogProps {
  isOpen: boolean;
  onDismiss: () => void;
  onSave: (managerIds: string[]) => void;
  users: any[];
  selectedManagers?: string[];
}

export const TenderingManagerDialog: React.FC<TenderingManagerDialogProps> = ({
  isOpen,
  onDismiss,
  onSave,
  users,
  selectedManagers = [],
}) => {
  const [selected, setSelected] = useState<string[]>([]);

  useEffect(() => {
    if (isOpen) {
      setSelected(selectedManagers || []);
    }
  }, [isOpen, selectedManagers]);

  const handleSave = () => {
    onSave(selected);
  };

  const handleSelectionChange = (userId: string, isChecked: boolean) => {
    if (isChecked) {
      setSelected([...selected, userId]);
    } else {
      setSelected(selected.filter(id => id !== userId));
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => !data.open && onDismiss()}>
      <DialogSurface style={{ minWidth: '500px', display: 'flex', flexDirection: 'column' }}>
        <DialogTitle>
          <Subtitle1>Handläggare</Subtitle1>
        </DialogTitle>
        <div className="py-4 space-y-2 min-h-[300px] max-h-[400px] overflow-y-auto">
          <h5 className="text-base font-medium mb-3">Välj handläggare</h5>
          {users.map((user) => (
            <div key={user.userID} className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded">
              <Checkbox
                checked={selected.includes(user.userID.toString())}
                onChange={(_, data) => handleSelectionChange(user.userID.toString(), data.checked === true)}
                label={user.fullName}
              />
            </div>
          ))}
        </div>
        <DialogActions>
          <Button appearance="secondary" onClick={onDismiss}>
            Avbryt
          </Button>
          <Button appearance="primary" onClick={handleSave}>
            OK
          </Button>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
};
